import React, { useState } from 'react'
import { Card, Select, Row, Col } from 'antd'
import { Line } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js'
import './MetricsPanel.css'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

const { Option } = Select

const MetricsPanel = ({ metrics }) => {
  const [timeRange, setTimeRange] = useState('1h')

  // 生成模拟时间序列数据（实际应从后端获取历史数据）
  const generateTimeSeriesData = (value, variance = 0.1) => {
    const points = 20
    const data = []
    for (let i = 0; i < points; i++) {
      const randomVariance = (Math.random() - 0.5) * variance * value
      data.push(Math.max(0, value + randomVariance))
    }
    return data
  }

  const generateLabels = (count) => {
    const labels = []
    const now = new Date()
    for (let i = count - 1; i >= 0; i--) {
      const time = new Date(now.getTime() - i * 60000) // 每分钟一个点
      labels.push(time.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' }))
    }
    return labels
  }

  const labels = generateLabels(20)

  // CPU 使用率图表
  const cpuChartData = {
    labels,
    datasets: [
      {
        label: 'CPU 使用率 (%)',
        data: generateTimeSeriesData(metrics?.system?.cpu_usage * 100 || 0, 0.2),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.1)',
        fill: true,
        tension: 0.4,
      },
    ],
  }

  // 内存使用图表
  const memoryChartData = {
    labels,
    datasets: [
      {
        label: '内存使用 (MB)',
        data: generateTimeSeriesData((metrics?.system?.memory_used || 0) / 1024 / 1024, 0.1),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.1)',
        fill: true,
        tension: 0.4,
      },
    ],
  }

  // API 响应时间图表
  const apiResponseChartData = {
    labels,
    datasets: [
      {
        label: '平均响应时间 (ms)',
        data: generateTimeSeriesData(metrics?.api?.avg_response_time || 0, 0.3),
        borderColor: 'rgb(153, 102, 255)',
        backgroundColor: 'rgba(153, 102, 255, 0.1)',
        fill: true,
        tension: 0.4,
      },
    ],
  }

  // 请求量图表
  const requestsChartData = {
    labels,
    datasets: [
      {
        label: '成功请求',
        data: generateTimeSeriesData(metrics?.api?.success_requests || 0, 0.2),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.1)',
        fill: true,
        tension: 0.4,
      },
      {
        label: '失败请求',
        data: generateTimeSeriesData(metrics?.api?.failed_requests || 0, 0.5),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.1)',
        fill: true,
        tension: 0.4,
      },
    ],
  }

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false,
    },
  }

  return (
    <div className="metrics-panel">
      <Card
        title="指标趋势"
        extra={
          <Select value={timeRange} onChange={setTimeRange} style={{ width: 120 }}>
            <Option value="1h">最近 1 小时</Option>
            <Option value="6h">最近 6 小时</Option>
            <Option value="24h">最近 24 小时</Option>
            <Option value="7d">最近 7 天</Option>
          </Select>
        }
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={12}>
            <div className="chart-container">
              <h4>CPU 使用率</h4>
              <div className="chart-wrapper">
                <Line data={cpuChartData} options={chartOptions} />
              </div>
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <div className="chart-container">
              <h4>内存使用</h4>
              <div className="chart-wrapper">
                <Line data={memoryChartData} options={chartOptions} />
              </div>
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <div className="chart-container">
              <h4>API 响应时间</h4>
              <div className="chart-wrapper">
                <Line data={apiResponseChartData} options={chartOptions} />
              </div>
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <div className="chart-container">
              <h4>API 请求量</h4>
              <div className="chart-wrapper">
                <Line data={requestsChartData} options={chartOptions} />
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  )
}

export default MetricsPanel
